import * as React from "react";

import { DataSourceMyBagTotalsControllerProvider } from "./data-source--mybag-totals-controller-provider";

export const DataSourceMyBagTotalsProvider: React.FunctionComponent = (
  props
) => {
  return (
    <DataSourceMyBagTotalsControllerProvider>
      {props?.children || []}
    </DataSourceMyBagTotalsControllerProvider>
  );
};
